var moment = require('moment');

module.exports = {

	model: {
		resourceFilters: {},
		teaserList: []
	},

	methods: {
		sanitizeResources: function(){
			// convert date
			moment.locale('de');
			for (var i in this.resourceData.data) {
				for(var j in this.resourceData.data[i].components){
					if (this.resourceData.data[i].components[j].date) {
						try {
							this.resourceData.data[i].components[j].date = moment(this.resourceData.data[i].components[j].date).format("Do MMMM YYYY");
						} catch(error){
							// do nothing on moment deprecation message
						}
					}
				}
			}
			this.model.teaserList = this.resourceData.data;
		},

		getResourceFilters: function(){
			return this.model.resourceFilters;
		},

		// update: function(searchTerm){
		// 	this.model.resourceFilters.search = searchTerm;
		// 	this.refresh();
		// }
	}
};